/**
 * This utility class helps to manage the loaders in the project
 */
export default class LoaderUtil {
  static get SELECTORS() {
    return {
      pageBrandLogoLoaderSel: '#page-brand-logo-loader',
      pageSpinLogoLoaderSel: '#page-spin-loader',
      loaderContainerSel: '.loader-container',
      cssActiveLoaderClass: 'active',
    };
  }

  static hideAllLoaderContainers() {
    $(LoaderUtil.SELECTORS.loaderContainerSel).removeClass(LoaderUtil.SELECTORS.cssActiveLoaderClass);
  }

  /**
   * Show the brand logo loader in the page
   */
  static showPageBrandLogoLoader() {
    LoaderUtil.hideAllLoaderContainers();

    $(LoaderUtil.SELECTORS.pageBrandLogoLoaderSel).addClass(LoaderUtil.SELECTORS.cssActiveLoaderClass);
  }

  /**
   * Hide the brand logo loader in the page
   */
  static hidePageBrandLogoLoader() {
    $(LoaderUtil.SELECTORS.pageBrandLogoLoaderSel).removeClass(LoaderUtil.SELECTORS.cssActiveLoaderClass);
  }

  /**
   * Show the spin loader in the page
   */
  static showPageSpinLogoLoader() {
    LoaderUtil.hideAllLoaderContainers();
    $(LoaderUtil.SELECTORS.pageSpinLogoLoaderSel).addClass(LoaderUtil.SELECTORS.cssActiveLoaderClass);

  }

  /**
   * Hide the spin loader in the page
   */
  static hidePageSpinLogoLoader() {
    $(LoaderUtil.SELECTORS.pageSpinLogoLoaderSel).removeClass(LoaderUtil.SELECTORS.cssActiveLoaderClass);
  }
}
